import React, { Component } from 'react';
import { observable } from 'mobx';
import PrimeResource from '../resources/prime-resouce';
import InvoiceResource from '../invoice/invoice-resource';
import * as uuide from 'uuid';
import moment from 'moment';
import Notifications from '../utils/notification-helper';

class Invoice {
    @observable date;
    @observable lineItem1;
    @observable invoiceId;
    @observable attention;
    @observable billTo;
    @observable billToEmail;
    @observable propertyAddress;
    @observable agentName;
    @observable brokerage;
    tcFileId;

    constructor() {
        this.invoiceId = uuide.v4();
        this.date = moment().format('MM/DD/YYYY');
    }
}

export default class InvoiceStore {
    @observable isLoading = false;
    @observable invoice = new Invoice();

    constructor(appStore) {
        this.appStore = appStore;
        this.primeResource = new PrimeResource();
        this.invoiceResource = new InvoiceResource();
    }

    createInvoice() {
        this.isLoading = true;
        return this.invoiceResource
            .createInvoice(this.appStore.authStore.getAccessToken(), this.invoice)
            .then(dataURI => {
                this.isLoading = false;
                return Promise.resolve(dataURI);
            })
            .catch(error => {
                this.isLoading = false;
                return Promise.reject(error);
            });
    }

    resetInvoice() {
        this.invoice = new Invoice();
    }
}



// WEBPACK FOOTER //
// ./src/invoice/invoice-store.js